import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination, Tabs } from 'antd';
import { Table, Button } from 'antd';
import { DownOutlined, ExclamationCircleOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import moment from 'moment';
import { pageFinanceRecordTypes, updateFinanceRecordType, createFinanceRecordType, IFinanceRecordType, enableFinanceRecordType } from '../../service/api/financeRecord';
import { FormInstance } from 'antd/lib/form/Form';
const { confirm } = Modal;
const { Option } = Select;

interface IFinanceRecordTypeListProps {
  visible: boolean
  setVisible: (visible: boolean) => void;
}
const FinanceRecordTypeList: React.FC<IFinanceRecordTypeListProps> = ({
  visible,
  setVisible,
}) => {
  const [financeRecordTypes, setFinanceRecordTypes] = useState<IFinanceRecordType[]>();
  const [financeRecordTypeDetail, setFinanceRecordTypeDetail] = useState<IFinanceRecordType>();
  const [pageNum, setPageNum] = useState(1);
  const [pageTotal, setPageTotal] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const formRef = React.createRef<FormInstance>();
  const [loading, setLoading] = useState(false);
  const columns = [
    {
      title: '名称',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '收入/支出',
      dataIndex: 'income',
      key: 'income',
      render: (text: any, record: any) => {
        if (record.income) {
          return <div style={{ backgroundColor: '#00A600', color: 'white', width: '50px', textAlign: 'center', borderRadius: '5px' }}>收入</div>
        } else {
          return <div style={{ backgroundColor: '#CE0000', color: 'white', width: '50px', textAlign: 'center', borderRadius: '5px' }}>支出</div>
        }
      }
    },
    // {
    //   title: '状态',
    //   dataIndex: 'enable',
    //   key: 'enable',
    //   render: (text: any, record: any) => {
    //     if (record.enable) {
    //       return <span style={{color:'green'}}>使用中</span>
    //     } else {
    //       return <span style={{color:'grey'}}>已停用</span>
    //     }
    //   }
    // },
    {
      title: '操作',
      key: 'action',
      render: (text: any, record: any) => {
        if (record.enable) {
          return <Space size="middle">
            <a onClick={() => {
              // console.log("record:" + JSON.stringify(record));
              setFinanceRecordTypeDetail({
                ...record,
                income: String(record.income),
              });
              setVisible(true);
            }}>编辑 </a>
            {/* <a onClick={e => { onEnable(e, record) }}>停用 </a> */}
          </Space>
        } else {
          return <Space size="middle">
            <a onClick={() => {
              // console.log("record:" + JSON.stringify(record));
              setFinanceRecordTypeDetail({
                ...record,
                income: String(record.income),
              });
              setVisible(true);
            }}>编辑 </a>
            {/* <a onClick={e => { onEnable(e, record) }}>启用 </a> */}
          </Space>
        }
      },
    }
  ];

  useEffect(() => {
    loadData();
  }, [pageNum, pageSize]);

  useEffect(() => {
    if (financeRecordTypeDetail) {
      // 设置100毫秒的延迟 确保from组件已经加载完毕
      setTimeout(() => {
        console.log('financeRecordTypeDetail', financeRecordTypeDetail);

        formRef.current!.setFieldsValue(financeRecordTypeDetail);
      }, 100);
    }
  }, [financeRecordTypeDetail]);

  const loadData = () => {
    pageFinanceRecordTypes(pageNum, pageSize, '').then((info: any) => {
      setFinanceRecordTypes(info?.data.list);
      setPageTotal(info?.data.total);
      // console.log("info:" + JSON.stringify(info.data));
    });
  }

  const onFinish = (values: any) => {
    setLoading(true);
    if (financeRecordTypeDetail) {
      updateFinanceRecordType({
        ...values,
        id: financeRecordTypeDetail.id
      }).then((info: any) => {
        // console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("更新成功");
          onClose();
          setLoading(false);
          loadData();
        }
      });
    } else {
      createFinanceRecordType(values).then((info: any) => {
        // console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("创建成功");
          onClose();
          setLoading(false);
          loadData();
        }
      });
    }
  };

  // const onEnable = (e: any, item: IFinanceRecordType) => {
  //   e.stopPropagation();
  //   confirm({
  //     title: '提示',
  //     icon: <ExclamationCircleOutlined />,
  //     content: item.enable?'确定要停用该财务类型吗？停用后无法被选到':'确定要启用该财务类型吗？',
  //     okText: '确定',
  //     okType: 'danger',
  //     cancelText: '取消',
  //     onOk() {
  //       enableFinanceRecordType(item.id, !item.enable).then((info: any) => {
  //         // console.log("info:" + JSON.stringify(info));
  //         if(info){
  //           message.success("操作成功");
  //           loadData();
  //         }
  //       });
  //     },
  //     onCancel() {
  //     },
  //   });
  // }

  const onClose = () => {
    setFinanceRecordTypeDetail(undefined);
    setVisible(false);
    if (formRef.current) {
      formRef.current!.resetFields();
    }
  }

  const onPageChange = (pageNum: number, pageSize?: number) => {
    setPageNum(pageNum);
    setPageSize(pageSize || 10);
    // setPageSize(info.data.pageSize);
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 4 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 20 },
    },
  };

  return (
    <Card bordered={false}>
      <Table dataSource={financeRecordTypes} columns={columns} pagination={false} />
      <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: "10px" }}>
        <Pagination
          defaultCurrent={pageNum}
          total={pageTotal}
          pageSize={pageSize}
          hideOnSinglePage={false}
          className="pagination"
          onChange={onPageChange}
          showSizeChanger
          showTotal={total => `共计 ${total} 条`}
        />
      </div>
      <Drawer
        title={financeRecordTypeDetail ? "编辑财务类型" : "新增财务类型"}
        visible={visible}
        width={720}
        onClose={onClose}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose
      >
        <Form onFinish={onFinish} ref={formRef} layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="名称"
                rules={[{ required: true, message: '请输入名称' }]}
              >
                <Input placeholder="请输入名称" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="income"
                label="收入/支出"
                rules={[{ required: false, message: '请选择收入/支出' }]}
              >
                <Select >
                  <Option value="true">收入</Option>
                  <Option value="false">支出</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>保存</Button>
                <Button htmlType="button" onClick={onClose}>取消</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </Card>
  );
};

export default FinanceRecordTypeList;
